import { GLOBAL_WILDCARD } from "@/features/rbac/permissions/catalog";
import type { PermissionOrWildcard } from "@/features/rbac/permissions/catalog";

/**
 * ¿El conjunto concedido cubre este permiso?
 *
 * Solo existen dos comodines, a propósito: `*` (todo) y `module:*` (todo un
 * módulo). Nada de coincidencias parciales o por prefijo, porque este matcher
 * tiene que ser reimplementable tal cual en `firestore.rules` y en la API REST.
 *
 * Los comodines se guardan sin expandir y se resuelven aquí, de modo que un rol
 * con `users:*` gana automáticamente un `users:view_stats` nuevo sin migrar
 * datos.
 */
export function matches(
  granted: ReadonlySet<string>,
  permission: PermissionOrWildcard
): boolean {
  if (granted.has(GLOBAL_WILDCARD) || granted.has(permission)) return true;

  const separator = permission.indexOf(":");
  if (separator <= 0) return false;

  return granted.has(`${permission.slice(0, separator)}:*`);
}

/** ¿El conjunto concedido cubre al menos uno de estos permisos? */
export function matchesAny(
  granted: ReadonlySet<string>,
  permissions: readonly PermissionOrWildcard[]
): boolean {
  return permissions.some((permission) => matches(granted, permission));
}

/** ¿El conjunto concedido cubre todos estos permisos? */
export function matchesAll(
  granted: ReadonlySet<string>,
  permissions: readonly PermissionOrWildcard[]
): boolean {
  return permissions.every((permission) => matches(granted, permission));
}
